<template>
    <div class="page-tabs-box">
        <div class="title">
            <el-alert type="info" effect="light" :closable="false">
                <div slot="title">
                    当前演出：<slot></slot>
                </div>
            </el-alert>
        </div>
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="基本信息"
                name="1"
				key="1"
                :link="`/activityManage/activity/edit/baseInfo/${id}`"
            ></el-tab-pane>
			<el-tab-pane
			    v-if="$utils.have('/activity/actSellSetting')"
			    label="演出售票设置"
			    name="2"
				key="2"
			    :link="`/activityManage/activity/edit/activityTicketPrices/${id}`"
			></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/activity/sessions')"
                label="场次设置"
                name="3"
				key="3"
                :link="`/activityManage/activity/edit/session/${id}`"
            ></el-tab-pane>
			<el-tab-pane
				v-if="$utils.have('/activity/batchUpdateSessions')"
			    label="批量更新场次信息"
			    name="16"
				key="16"
			    :link="`/activityManage/activity/edit/batchUpdate/${id}`"
			></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/activity/ticketPrices')"
                label="场次售票设置"
                name="4"
				key="4"
                :link="`/activityManage/activity/edit/sessionsTicketPrices/${id}`"
            ></el-tab-pane>			
            <el-tab-pane
                v-if="$utils.have('/activity/throughTicketPrices')"
                label="通票设置"
                name="5"
				key="5"
                :link="`/activityManage/activity/edit/throughTicketPrices/${id}`"
            ></el-tab-pane>			
			<el-tab-pane
				v-if="$utils.have('/activity/presentTicketPrices')"
				label="赠票管理"
				name="6"
				key="6"
				:link="`/activityManage/activity/edit/presentTicket/${id}`"
			></el-tab-pane>
			<!-- <el-tab-pane
				v-if="$utils.have('/activity/activitySeatInfo')"
				label="选座设置"
				name="15"
				key="15"
				:link="`/activityManage/activity/edit/seatConfig/${id}`"
			></el-tab-pane>		 -->	     
			<el-tab-pane
			    v-if="$utils.have('/missTicket/pageList')"
			    label="票品登记"
			    name="7"
				key="7"
			    :link="`/activityManage/activity/edit/lackTicket/${id}`"
			></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/activity/approval')"
                label="报批信息"
                name="8"
				key="8"
                :link="`/activityManage/activity/edit/approval/${id}`"
            ></el-tab-pane>
            <el-tab-pane
				v-if="$utils.have('/activity/financeInfo')"
                label="财务信息"
                name="9"
				key="9"
                :link="`/activityManage/activity/edit/finance/${id}`"
            ></el-tab-pane>
            <el-tab-pane
				v-if="$utils.have('/activityUpdateRecord/list')"
                label="变更通知"
                name="10"
				key="10"
                :link="`/activityManage/activity/edit/changeNotice/${id}`"
            ></el-tab-pane>			
			<el-tab-pane
				v-if="$utils.have('/activity/thirdList')"
				label="外部销售"
				name="11"
				key="11"
				:link="`/activityManage/activity/edit/thirdList/${id}`"
			></el-tab-pane>			
            <el-tab-pane
				v-if="$utils.have('/activity/thirdTicket')"
                label="主办自有售票渠道数据"
                name="12"
				key="12"
                :link="`/activityManage/activity/edit/thirdTicket/${id}`"
            ></el-tab-pane>
			<el-tab-pane
				v-if="$utils.have('/activity/statistics/summary')"
			    label="数据统计"
			    name="13"
				key="13"
			    :link="`/activityManage/activity/edit/activityDashboard/${id}`"
			></el-tab-pane>
			<el-tab-pane
				v-if="$utils.have('/activityUpdateLog/list')"
			    label="修改日志"
			    name="14"
				key="14"
			    :link="`/activityManage/activity/edit/updateLog/${id}`"
			></el-tab-pane>
			<el-tab-pane
				v-if="$utils.have('/activity/souvenir/ticket/detail')"
			    label="纪念票设置"
			    name="18"
				key="18"
			    :link="`/activityManage/activity/edit/souvenir/${id}`"
			></el-tab-pane>
			<!-- 演出其他设置：首页推荐设置改名并移至最后一个tab -->
			<el-tab-pane
				v-if="$utils.have('/activity/getSortScore')"
			    label="演出其他设置"
			    name="17"
			    key="17"
			    :link="`/activityManage/activity/edit/sort/${id}`"
			></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
		
    },
    data() {
        return {
            activeName: this.name,
            id: this.$route.params.id,	
			channelName:''
        };
    },
	
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
		
    },
};
</script>

<style lang="scss" scoped>
.title {
    font-size: 20px;
    margin: -20px -20px 10px -20px;
    .el-alert{
        border-radius: 0;
    }
}
.el-tabs {
    // margin-bottom: 10px;

    ::v-deep .el-tabs__header {
        margin-left: -20px;
        margin-right: -20px;
        .el-tabs__nav-wrap {
            padding: 0 20px;
            .el-tabs__item {
                font-size: 16px;
            }
        }
    }
}
</style>